import { render, staticRenderFns } from "./AgeGroupView.vue?vue&type=template&id=46bda50a&scoped=true&"
import script from "./AgeGroupView.vue?vue&type=script&lang=js&"
export * from "./AgeGroupView.vue?vue&type=script&lang=js&"
import style0 from "./AgeGroupView.vue?vue&type=style&index=0&id=46bda50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bda50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46bda50a')) {
      api.createRecord('46bda50a', component.options)
    } else {
      api.reload('46bda50a', component.options)
    }
    module.hot.accept("./AgeGroupView.vue?vue&type=template&id=46bda50a&scoped=true&", function () {
      api.rerender('46bda50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/sign-draw/view/AgeGroupView.vue"
export default component.exports